import { gql } from '@apollo/client'

export const SEND_START_CALL_EVENT = gql`
    mutation SendStartCallEvent($input: StartCallInput!) {
        sendStartCallEvent(input: $input) {
            success
            notice
        }
    }
`